// Modules
import { useCallback } from 'react'
import { DocumentNode, useApolloClient } from '@apollo/client'

// Application
import { UserCIPResponse, UserResponse } from 'typings/user'
import { Viewer, ViewerCIP } from 'services/gql/user/query'
import { ViewerFeatureFlag } from 'services/gql/auth/mutation'

export const useUserService = () => {
    const client = useApolloClient()

    const getPartialUser = useCallback(
        async (partialGql: DocumentNode) => {
            const result = await client.query<UserResponse>({
                query: partialGql,
            })

            return result?.data?.viewer
        },
        [client],
    )

    const getUserFromBase = async () => {
        const result = await client.query<UserResponse>({
            query: Viewer,
            fetchPolicy: 'network-only',
        })

        return result?.data.viewer
    }

    const getUserCIPFromBase = async () => {
        const result = await client.query<UserCIPResponse>({
            query: ViewerCIP,
            fetchPolicy: 'network-only',
        })

        return result?.data.viewerCIP
    }

    const getUserFeatureFlags = async () => {
        const result = await getPartialUser(ViewerFeatureFlag)

        return result
    }

    return {
        getPartialUser,
        getUserFromBase,
        getUserCIPFromBase,
        getUserFeatureFlags,
    }
}
